import { api } from "@/lib/api";

let el = null;
let unlocked = localStorage.getItem("tf_audio_ok") === "1";

const audio = (id) => document.getElementById(id);

/** Destrava o áudio (precisa ser chamado a partir de um toque do usuário). */
export async function unlockAlerts() {
  const jingle = audio("tf-jingle");
  const coin = audio("tf-coin");
  let ok = false;
  for (const a of [jingle, coin]) {
    if (!a) continue;
    try {
      a.muted = true;
      await a.play();
      a.pause();
      a.currentTime = 0;
      a.muted = false;
      ok = true;
    } catch {
      a.muted = false;
    }
  }
  unlocked = ok;
  localStorage.setItem("tf_audio_ok", ok ? "1" : "0");
  return ok;
}

export const alertsUnlocked = () => unlocked;

export async function playAlert(kind = "jingle") {
  el = audio(kind === "coin" ? "tf-coin" : "tf-jingle");
  if (!el) return false;
  try {
    el.currentTime = 0;
    el.volume = 1;
    await el.play();
    return true;
  } catch {
    return false;
  }
}

function b64ToUint8Array(base64) {
  const pad = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

/** Pede permissão e registra o dispositivo para receber notificação no celular. */
export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return { ok: false, reason: "Este navegador não suporta notificações. Instale o app na tela de início." };
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    return { ok: false, reason: "Permissão de notificação negada nas configurações do navegador." };
  }
  try {
    const reg = await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public-key");
    if (!data.publicKey) return { ok: false, reason: "Servidor sem chave de push configurada." };
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: b64ToUint8Array(data.publicKey),
      });
    }
    await api.post("/push/subscribe", sub.toJSON());
    localStorage.setItem("tf_push_ok", "1");
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: e.message || "Não foi possível registrar o dispositivo." };
  }
}

export const pushEnabled = () =>
  typeof Notification !== "undefined" && Notification.permission === "granted" &&
  localStorage.getItem("tf_push_ok") === "1";

/** Notificação do sistema mesmo sem push (app aberto). */
export function systemNotify(title, body) {
  try {
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      new Notification(title, { body, icon: "/timefood-192.png", tag: "timefood-live" });
    }
  } catch { /* ignore */ }
}
